<common-top-tool-bar [title]="'英语王者题库'" [actionsTemplate]="actionsTpl">
  <ng-template #actionsTpl>
    <button
      nz-button
      nzDanger
      nzSize="large"
      class="mr-4"
      type="button"
      [disabled]="setOfCheckedId.size === 0"
      (click)="confirmBatchDelete()"
    >
      批量删除
    </button>
    <button nz-button nzType="primary" nzSize="large" routerLink="/admin/v3/game/exercise-bank/batch">
      <i nz-icon nzType="plus" nzTheme="outline"></i>
      批量添加题库
    </button>
  </ng-template>
</common-top-tool-bar>

<div class="page-main game-level-exercise-bank-index">
  <nz-spin [nzSpinning]="filtersLoading">
    <tw-table-filter
      actionStyle="align-items: center;display: flex;"
      wrapperStyle="height: auto; padding-bottom: 1em;"
      (doFilter)="doFilter($event)"
    >
      <nz-select
        class="m-2 filter-select"
        nzAllowClear
        nzShowSearch
        [nzDropdownMatchSelectWidth]="false"
        nzPlaceHolder="级别"
        [(ngModel)]="filterLevelId"
      >
        <nz-option *ngFor="let lv of gameLevels" [nzValue]="lv.id" [nzLabel]="lv.name + ' (' + lv.levelCode + ')'"></nz-option>
      </nz-select>

      <nz-cascader
        class="m-2 filter-cascader"
        nzAllowClear
        nzShowSearch
        nzPlaceHolder="资源路径"
        [nzOptions]="pathCascaderOptions"
        [nzValueProperty]="'id'"
        [nzLabelProperty]="'name'"
        [nzChangeOnSelect]="false"
        [(ngModel)]="pathCascaderValues"
        (ngModelChange)="onPathCascaderChange($event)"
      ></nz-cascader>

      <nz-select
        *ngIf="pathCascaderValues?.length >= 2"
        class="m-2 filter-select filter-select-wide"
        nzAllowClear
        nzShowSearch
        [nzDropdownMatchSelectWidth]="false"
        nzPlaceHolder="习题包"
        [(ngModel)]="filterExerciseId"
      >
        <nz-option *ngFor="let ex of exerciseOptions" [nzValue]="ex.id" [nzLabel]="ex.name"></nz-option>
      </nz-select>

      <button nz-button class="m-2" (click)="resetFilters()">重置</button>
    </tw-table-filter>
  </nz-spin>

  <ng-template #rangeTemplate let-range="range" let-total>
    显示 {{ total }} 条资料中的 {{ range[0] }} 到 {{ range[1] }} 条数据
  </ng-template>

  <div class="page-main-table">
    <nz-table
      class="data-table"
      #dataTable
      [nzData]="rows"
      [nzLoading]="loading"
      nzTableLayout="fixed"
      [nzFrontPagination]="false"
      [nzPageIndex]="pageIndex"
      [nzPageSize]="pageSize"
      [nzTotal]="total"
      [nzShowPagination]="true"
      [nzShowSizeChanger]="true"
      [nzPageSizeOptions]="[10, 20, 50]"
      [nzShowTotal]="rangeTemplate"
      (nzQueryParams)="onQueryParamsChange($event)"
      [nzScroll]="{ x: '1320px' }"
    >
      <thead>
        <tr>
          <th
            nzWidth="48px"
            nzShowCheckbox
            [nzChecked]="checked"
            [nzIndeterminate]="indeterminate"
            (nzCheckedChange)="onAllChecked($event)"
          ></th>
          <th nzWidth="100px">资源id</th>
          <th nzWidth="120px">级别</th>
          <th nzWidth="200px">资源路径</th>
          <th nzWidth="160px">所属题包</th>
          <th nzWidth="220px">题干</th>
          <th nzWidth="168px">创建时间</th>
          <th nzRight nzWidth="100px">操作</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of dataTable.data; trackBy: trackById">
          <td
            nzShowCheckbox
            [nzChecked]="setOfCheckedId.has(row.id)"
            (nzCheckedChange)="onItemChecked(row.id, $event)"
          ></td>
          <td>{{ row.id }}</td>
          <td nzEllipsis nz-tooltip [nzTooltipTitle]="row.levelName">{{ displayText(row.levelName) }}</td>
          <td nzEllipsis nz-tooltip [nzTooltipTitle]="displayText(row.pathName)">{{ displayText(row.pathName) }}</td>
          <td nzEllipsis nz-tooltip [nzTooltipTitle]="row.packageName">{{ displayText(row.packageName) }}</td>
          <td nzEllipsis nz-tooltip [nzTooltipTitle]="displayText(row.questionContent)">
            {{ displayText(row.questionContent) }}
          </td>
          <td>{{ displayText(row.createdAt) }}</td>
          <td nzRight>
            <a
              nz-button
              nzType="link"
              nzDanger
              nzSize="small"
              (click)="confirmDeleteOne(row)"
            >删除</a>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</div>
